module.exports = __webpack_public_path__ + "assets/media/day38.5def6d73.mp3";